
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/submit-an-update",
      function () {
        return require("private-next-pages/submit-an-update.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/submit-an-update"])
      });
    }
  